(function () {
  'use strict';

  var container = document.querySelector('[data-product-videos-grid]');
  if (!container) return;

  var shopDomain = container.dataset.shopDomain;
  var accessToken = container.dataset.accessToken;
  var perPage = parseInt(container.dataset.perPage, 10) || 24;
  var sectionId = container.dataset.sectionId;
  var playButtonColor = container.dataset.playButtonColor || '#fff';

  var grid = container.querySelector('[data-videos-grid]');
  var paginationEl = container.querySelector('[data-videos-pagination]');
  var loadingEl = container.querySelector('[data-videos-loading]');

  var allVideos = [];
  var currentPage = 1;

  // video field is a list reference (Liquid: product_video.video.value | first)
  // model field is a single reference (Liquid: product_video.model.value)
  // product_variants field is a list reference (Liquid: product_video.product_variants.value)
  var QUERY = '\
query GetProductVideos($first: Int!, $after: String) {\
  metaobjects(type: "product_video", first: $first, after: $after, sortKey: "id") {\
    edges {\
      node {\
        id\
        handle\
        fields {\
          key\
          value\
          reference {\
            ... on Metaobject {\
              id\
              fields {\
                key\
                value\
                reference {\
                  ... on MediaImage {\
                    image { url }\
                  }\
                }\
              }\
            }\
          }\
          references(first: 20) {\
            edges {\
              node {\
                ... on Video {\
                  sources { url mimeType }\
                  previewImage { url }\
                }\
                ... on ProductVariant {\
                  id\
                  price { amount currencyCode }\
                  compareAtPrice { amount currencyCode }\
                  product {\
                    title\
                    vendor\
                    onlineStoreUrl\
                    featuredImage { url }\
                  }\
                }\
              }\
            }\
          }\
        }\
      }\
    }\
    pageInfo { hasNextPage endCursor }\
  }\
}';

  function fetchPage(after) {
    return fetch('https://' + shopDomain + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({ query: QUERY, variables: { first: 50, after: after || null } })
    }).then(function (r) { return r.json(); });
  }

  function fetchAll() {
    var results = [];
    function next(cursor) {
      return fetchPage(cursor).then(function (data) {
        var edges = (data.data && data.data.metaobjects && data.data.metaobjects.edges) || [];
        edges.forEach(function (e) { results.push(e.node); });
        var pageInfo = data.data && data.data.metaobjects && data.data.metaobjects.pageInfo;
        if (pageInfo && pageInfo.hasNextPage) {
          return next(pageInfo.endCursor);
        }
        return results;
      });
    }
    return next(null);
  }

  function getField(fields, key) {
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].key === key) return fields[i];
    }
    return null;
  }

  function parseNode(node, index) {
    var fields = node.fields || [];

    var videoField = getField(fields, 'video');
    var modelField = getField(fields, 'model');
    var variantsField = getField(fields, 'product_variants');

    // video: list reference -> use references, take first Video node
    var sources = [];
    var previewUrl = '';
    if (videoField && videoField.references) {
      var videoEdges = videoField.references.edges || [];
      for (var vi = 0; vi < videoEdges.length; vi++) {
        var vnode = videoEdges[vi].node;
        if (vnode && vnode.sources) {
          sources = vnode.sources;
          previewUrl = vnode.previewImage ? vnode.previewImage.url : '';
          break;
        }
      }
    }

    // model: single reference -> use reference (Metaobject)
    var modelData = null;
    if (modelField && modelField.reference && modelField.reference.fields) {
      var mfields = modelField.reference.fields;
      var mname = getField(mfields, 'name');
      var mimage = getField(mfields, 'image');
      var mheight = getField(mfields, 'height');
      var mig = getField(mfields, 'instagram');
      modelData = {
        name: mname ? mname.value : '',
        avatarUrl: (mimage && mimage.reference && mimage.reference.image) ? mimage.reference.image.url : '',
        height: mheight ? mheight.value : '',
        instagram: mig ? mig.value : ''
      };
    }

    // product_variants: list reference -> use references
    var products = [];
    if (variantsField && variantsField.references) {
      var vEdges = variantsField.references.edges || [];
      vEdges.forEach(function (e) {
        var v = e.node;
        if (!v || !v.product) return;
        var priceFmt = v.price
          ? parseFloat(v.price.amount).toLocaleString('ja-JP', { style: 'currency', currency: v.price.currencyCode })
          : '';
        var compareFmt = (v.compareAtPrice && parseFloat(v.compareAtPrice.amount) > parseFloat(v.price.amount))
          ? parseFloat(v.compareAtPrice.amount).toLocaleString('ja-JP', { style: 'currency', currency: v.compareAtPrice.currencyCode })
          : null;
        products.push({
          url: v.product.onlineStoreUrl || '',
          imageUrl: v.product.featuredImage ? v.product.featuredImage.url : '',
          brand: v.product.vendor || '',
          title: v.product.title || '',
          price: priceFmt,
          compareAtPrice: compareFmt
        });
      });
    }

    return { index: index, sources: sources, previewUrl: previewUrl, model: modelData, products: products };
  }

  function renderGrid(page) {
    currentPage = page;
    var start = (page - 1) * perPage;
    var pageVideos = allVideos.slice(start, start + perPage);

    grid.innerHTML = '';

    pageVideos.forEach(function (v, i) {
      var globalIndex = start + i;
      var btn = document.createElement('button');
      btn.className = 'product_videos tw-relative tw-w-full tw-border-0 tw-p-0 tw-bg-transparent tw-cursor-pointer';
      btn.setAttribute('data-video-modal-trigger', '');
      btn.setAttribute('data-video-modal-section', sectionId);
      btn.setAttribute('data-video-modal-index', globalIndex);
      btn.setAttribute('aria-label', '動画を再生');

      if (v.previewUrl) {
        var img = document.createElement('img');
        img.src = v.previewUrl;
        img.className = 'tw-aspect-[9/16] tw-object-cover tw-w-full';
        img.loading = 'lazy';
        btn.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className = 'tw-aspect-[9/16] tw-bg-gray-200 tw-w-full';
        btn.appendChild(placeholder);
      }

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('width', '48');
      svg.setAttribute('height', '48');
      svg.setAttribute('viewBox', '0 0 48 48');
      svg.setAttribute('class', 'tw-absolute tw-top-1/2 tw-transform tw--translate-y-1/2 tw-left-1/2 tw--translate-x-1/2');
      svg.style.zIndex = '1';
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill-rule', 'evenodd');
      path.setAttribute('clip-rule', 'evenodd');
      path.setAttribute('d', 'M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24Zm-18 0-9-6.6v13.2l9-6.6Z');
      path.setAttribute('fill', playButtonColor);
      svg.appendChild(path);
      btn.appendChild(svg);

      grid.appendChild(btn);
    });

    renderPagination(page);
    injectModalData();
  }

  function injectModalData() {
    var existing = document.getElementById('video-modal-data-' + sectionId);
    if (existing) existing.remove();

    var script = document.createElement('script');
    script.id = 'video-modal-data-' + sectionId;
    script.type = 'application/json';
    script.textContent = JSON.stringify(allVideos.map(function (v, i) {
      return { index: i, sources: v.sources, model: v.model, products: v.products };
    }));
    document.body.appendChild(script);
  }

  function renderPagination(page) {
    if (!paginationEl) return;
    var totalPages = Math.ceil(allVideos.length / perPage);
    if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

    var html = '<nav class="tw-flex tw-gap-2 tw-justify-center tw-flex-wrap">';
    if (page > 1) html += '<button class="tw-px-3 tw-py-1 tw-border tw-rounded" data-page="' + (page - 1) + '">&laquo; 前へ</button>';

    for (var i = 1; i <= totalPages; i++) {
      var active = i === page ? ' tw-bg-black tw-text-white' : '';
      html += '<button class="tw-px-3 tw-py-1 tw-border tw-rounded' + active + '" data-page="' + i + '">' + i + '</button>';
    }

    if (page < totalPages) html += '<button class="tw-px-3 tw-py-1 tw-border tw-rounded" data-page="' + (page + 1) + '">次へ &raquo;</button>';
    html += '</nav>';
    paginationEl.innerHTML = html;

    paginationEl.querySelectorAll('[data-page]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        renderGrid(parseInt(btn.dataset.page, 10));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  function init() {
    if (!accessToken) {
      if (loadingEl) loadingEl.textContent = 'Storefront Access Token が設定されていません。テーマ設定 > Storefront API から設定してください。';
      return;
    }

    fetchAll().then(function (nodes) {
      nodes.reverse();
      allVideos = nodes.map(function (node, i) { return parseNode(node, i); });
      if (loadingEl) loadingEl.style.display = 'none';
      renderGrid(1);
    }).catch(function (err) {
      console.error('product-videos-grid:', err);
      if (loadingEl) loadingEl.textContent = '動画の読み込みに失敗しました。';
    });
  }

  init();
})();
